import Modal from './modal';
import Form from './form';
import getLayout from './get-modal-layout';

class ModalForm extends Modal {
  constructor() {
    super();
    this.toggles = [...this.page.querySelectorAll(`.js-modal-form`)];
    this.formTemplate = this.page.querySelector(`.js-form-content`);
    this.type = this.formTemplate && this.formTemplate.dataset.type;
  }

  init() {
    this.bindHandlers();
    super.createModal();
    this.createFormWrap();
  }

  createFormWrap() {
    if (!this.formTemplate || !this.formTemplate.content.childNodes.length) return;

    super.addLayout(getLayout(`form`));
    this.createForm();
  };

  createForm() {
    const wrap = this.page.querySelector(`#modal-form`);

    wrap.appendChild(this.formTemplate.content.cloneNode(true));

    if (this.type === `flats`) {
      this.initContactsForm();

      return;
    }

    if (this.type === `main`) {
      this.initMainForm();

      return;
    }

    this.initContactsForm();
  }

  initContactsForm() {
    const contactsForm = new Form(`contacts-form`, `contacts`);

    contactsForm.init();
  };

  initMainForm() {
    const mainForm = new Form(`main-form`, `main`);

    mainForm.init();
  };

  bindHandlers() {
    this.toggles.forEach(toggle => {
      toggle.addEventListener(`click`, (e) => {
        e.preventDefault();

        this._toggleModal(true);
      })
    });
  }
}

const modalForm = new ModalForm();

export default modalForm;
